<script>
  import Topbar from '@components/topbar'
  import AppMenu from '@components/appMenu'

  export default {
    components: { Topbar, AppMenu },
    data() {
      return {
        showMobileMenu: false,
        // user: this.$store ? this.$store.state.auth.currentUser : {} || {},
      }
    },
    created: () => {
      document.body.classList.remove('authentication-bg')
      document.body.classList.remove('authentication-bg-pattern')
      document.body.setAttribute('data-layout', 'topnav')
      document.body.classList.remove('right-bar-enabled')
      document.body.classList.remove('left-side-menu-condensed')
      document.body.classList.remove('boxed-layout')
    },
    methods: {
      toggleMenu() {
        this.showMobileMenu = !this.showMobileMenu
      }
    },
  }
</script>

<template>
  <div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->
    <div class="topnav d-flex">
      <div class="" style="width: 18vw; height:100vh;background-color: #1e1e2d;box-shadow: 2px 4px 60px 0px rgba(0, 0, 0, 0.15);">
        <!-- <nav class="navbar navbar-light navbar-expand-lg topbar-nav">
          <b-collapse
          id="topnav-menu-content"
          v-model="showMobileMenu"
          class="navbar-collapse"
          > -->
          <AppMenu mode="horizontal" class=""/>
        <!-- </b-collapse>
      </nav> -->
    </div>
    <div class="content-page w-100 bg-light">
        <Topbar :user="user" :is-menu-opened="showMobileMenu" class="bg-white" />
          <div class="pt-5" style="overflow-y: scroll; height: calc(100vh - 75px);background-color: #f5f8fa;">
            <slot />
          </div>
      </div>
    </div>
    <!-- <RightSidebar /> -->
  </div>
</template>
